import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import MobileCard from './MobileCard';
import { USDollar } from '../../utilities/Constants';
import { formatPhoneNumber } from '../../utilities/PhoneFormat';

export default function PendingApprovalsCardMobile(props) {
    const { pendingApproval, setShowApproveDialog, setShowDenyDialog } = props;

    return (
        <MobileCard
            title={`Unit ${pendingApproval.storageUnit.name}`}
            subtitle={`${pendingApproval.appUser.firstName} ${pendingApproval.appUser.lastName}`}
            status={{ label: 'Pending', color: 'info' }}
            fields={[
                { label: 'Email', value: pendingApproval.appUser.username },
                { label: 'Phone', value: formatPhoneNumber(pendingApproval.appUser.phone) },
                { label: 'Licence', value: pendingApproval.appUser.driversLicenseNumber },
                { label: 'Size', value: pendingApproval.storageUnit.storageSize },
                { label: 'Price', value: USDollar.format(pendingApproval.storageUnit.price) },
            ]}
            actions={
                <>
                    <Button variant={'contained'} onClick={setShowApproveDialog}>Approve</Button>
                    <Button variant={'outlined'} color={'error'} onClick={setShowDenyDialog}>Deny</Button>
                </>
            }
        />
    );
}

PendingApprovalsCardMobile.propTypes = {
    pendingApproval: PropTypes.object,
    setShowApproveDialog: PropTypes.func,
    setShowDenyDialog: PropTypes.func,
};
